module.exports = __webpack_public_path__ + "static/media/kcell.d929c0e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/kcell.svg
// module id = 886
// module chunks = 7